<template>
    <footer class="p-sm-4 bg-dark text-light">
        <div class="container py-4">
            <div class="row gy-4 gx-5 d-flex align-items-center">
                <div class="col-sm-3">
                    <a href="/"><img :src="G.systemData?.footer_logo?.value" :alt="G.projectName" style="width: 250px;" /></a>
                    <!-- <h5 class="h3">{{G.projectName}}</h5> -->
                </div>
                <div class="col-sm-9">
                    <p class="small1 fs-6">{{G.systemData?.slogan?.value}}</p>
                </div>
                <!-- <div class="col-lg-3 offset-sm-1 col-md-6">
                    <h5 class="mb-3">Menyu</h5>
                    <ul class="list-unstyled">
                        <li v-for="(item, index) in data" :key="index">
                            <a :href="item.link">{{ item.translate.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-2 col-md-6">
                    <h5 class="mb-3">Əlavələr</h5>
                    <ul class="list-unstyled">
                        <li><a href="#">Supports</a></li>
                        <li><a href="#">Faqs</a></li>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">News and blogs</a></li>
                        <li><a href="#">News Terms & condition</a></li>
                    </ul>
                </div> -->

                <!-- <div class="col-lg-4 col-md-6">
                    <h5 class="mb-3">Xəbər bülleteni</h5>
                    <p class="small">Xəbər bülleteninə qoşulmaqla Siz daima yeniliklərdən xəbərdar olacaqsınız.</p>
                    <form action="#">
                        <div class="input-group mb-3">
                            <input class="form-control" type="text" placeholder="Sizin email ünvanınız" aria-label="..." aria-describedby="button-addon2">
                            <button class="btn btn-secondary" id="button-addon2" type="button"><i class="fas fa-paper-plane"></i></button>
                        </div>
                    </form>
                </div> -->

                <!-- <div class="col-lg-2 offset-sm-1 col-md-6">
                    <div class="dropdown text-sm-end mt-3 mt-md-0">
                        <a class="dropdown-toggle btn btn-sm btn-light mb-0" href="#" role="button" id="languageSwitcher" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fas fa-language me-2"></i>{{ TR.language }}
                        </a>
                        <ul class="dropdown-menu min-w-auto" aria-labelledby="languageSwitcher">
                            <li><a class="dropdown-item me-4" href="#"><img class="fa-fw me-2" src="assets/images/flags/az.svg" alt="">Azerbaijan</a></li>
                            <li><a class="dropdown-item me-4" href="#"><img class="fa-fw me-2" src="assets/images/flags/sp.svg" alt="">Russian</a></li>
                            <li><a class="dropdown-item me-4" href="#"><img class="fa-fw me-2" src="assets/images/flags/uk.svg" alt="">English</a></li>
                        </ul>
                    </div>
                </div> -->

            </div>


            <div class="row row-cols-1 row-cols-sm-2 mt-4 pt-3 border-1 border-top small">
                <div class="col">
                    <p v-html="G.footerPowered"></p>
                </div>
                <div class="col d-flex">
                    <ul class="list-unstyled d-flex ms-auto">
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-google"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                    </ul>
                </div>
            </div>

        </div>
    </footer>
</template>


<script>
import { G } from '@/_common';

export default {
    name: 'FooterC',
    props:{
        data:{
            type: Array,
            default: () => []
        },
        TR:{
            type: Object,
            default: () => {}
        }
    },
    setup() {
        return { G };
    },
}
</script>

<style lang="scss" scoped>
.store-footer {
    a{
        color: #c9c9c9;
    }
    a:hover{
        color: rgb(128, 128, 128);
    }
    .social-links > a{
        display: flex;
        // padding: 8px;
        margin: 10px;
        width: 60px;
        height: 60px;
        background-color: #443f3f;
        border-radius: 50%;
        // font-size: 18pt;
        font-size: calc(var(--bs-body-font-size) * 1.2);
        justify-content: center;
        align-items: center;
        // color: black;
    }
    .social-links > a:hover{
        background-color: #b3b3b3;
    }
}
</style>
